<script>
import {
  mesAchatsFiltersEmits,
  mesAchatsFiltersProps,
  useMesAchatsFilters
} from "./mixin";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import Divider from "@/components/atoms/divider";
import Accordion from "@/components/molecules/accordion";
import AccordionItem from "@/components/molecules/accordion/accordion-item";
import AppliedFilters from "@/components/organisms/product-list/product-list-header/applied-filters/mobile";
import FormGroup from "@/components/molecules/form-group";
import FormRadio from "@/components/molecules/form-radio";
import FormCheckbox from "@/components/molecules/form-checkbox";
import FormInput from "@/components/molecules/form-input";
import Filtersearch from "@/components/molecules/filter-search";
import Icon from "@/components/atoms/icon";
import StickyFooter from "@/components/molecules/sticky-footer";

export default {
  name: "MesAchatsFiltersMobile",
  components: {
    ButtonIcon,
    Button,
    Accordion,
    AccordionItem,
    AppliedFilters,
    Divider,
    FormGroup,
    FormRadio,
    FormInput,
    Filtersearch,
    Icon,
    FormCheckbox,
    StickyFooter
  },
  props: {
    ...mesAchatsFiltersProps()
  },
  emits: [
    "toggleFilter",
    "supprimerFiltre",
    "supprimerToutFiltres",
    ...mesAchatsFiltersEmits()
  ],
  methods: {
    closeAllFilters() {
      this.$refs.accordionFilters.closeAll();
    },
    toggleFilter() {
      this.$emit("toggleFilter");
    },
    supprimerFiltre(checked, code, value) {
      this.$emit("supprimerFiltre", checked, code, value);
    }
  },
  setup(props, context) {
    const collapsible = ref([]);
    const {
      dateMinInput,
      dateMaxInput,
      montantMinInput,
      montantMaxInput,
      garantieInput,
      searchWord,
      libellePeriode,
      filtreMagasin,
      dateSelectorDisabled,
      montantSelectorDisabled,
      magasinsSearchResult,
      searchMagasin,
      updateDate,
      updateMontant,
      updateMagasin,
      updateGarantie,
      syncFiltres
    } = useMesAchatsFilters(props, context);

    onBeforeMount(syncFiltres);

    return {
      dateMinInput,
      dateMaxInput,
      montantMinInput,
      montantMaxInput,
      garantieInput,
      searchWord,
      libellePeriode,
      filtreMagasin,
      dateSelectorDisabled,
      montantSelectorDisabled,
      magasinsSearchResult,
      searchMagasin,
      updateDate,
      updateMontant,
      updateMagasin,
      updateGarantie,
      collapsible
    };
  }
};
</script>

<template>
  <div class="u-bgcolor-white u-flex u-flex-column u-full-height">
    <div class="u-flex-grow u-flex u-flex-column u-mb-xlg">
      <div class="u-flex u-flex-align-center u-flex-justify-between u-font-secondary u-color-primary u-font-21 u-font-700 u-py-sm u-px-sm">
        <div>
          Filtrer
        </div>
        <ButtonIcon
          icon-color="grey-9"
          icon-name="cross"
          aria-label="Masquer les filtres"
          @click="toggleFilter()"
        />
      </div>
      <AppliedFilters
        :applied-filters="appliedFilters"
        :filters-to-apply="appliedFilters"
        key-code
        @select="supprimerFiltre"
        @updateFiltersToApply="$emit('supprimerToutFiltres')"
      />
      <div class="u-px-sm">
        <FormCheckbox
          v-model="garantieInput"
          class="u-px-xs u-my-md"
          @change="updateGarantie"
        >
          <span class="u-font-14">
            Ticket avec produit sous garantie
          </span>
        </FormCheckbox>
        <Divider />
      </div>
      <Accordion
        ref="accordionFilters"
        :items="collapsible"
        class="u-bgcolor-white u-pr-sm u-pl-sm"
      >
        <AccordionItem
          :ref="(el) => { collapsible.push(el) }"
          :opened="false"
        >
          <template #title>
            <span class="u-font-16 u-font-700 u-py-sm">
              Période d’achat
            </span>
          </template>

          <div class="u-p-sm">
            <FormGroup class="u-mb-md">
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="thisMonth"
                @change="updateDate()"
              >
                Ce mois-ci
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="lastMonth"
                @change="updateDate()"
              >
                Le mois dernier
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                class="u-mb-sm"
                value="lastThreeMonth"
                @change="updateDate()"
              >
                Les 3 derniers mois
              </Formradio>
              <FormRadio
                v-model="libellePeriode"
                value="custom"
              >
                Période personnalisée
              </Formradio>
            </FormGroup>
            <div class="c-filter-achat-mobile__inputs-wrapper">
              <div class="c-filter-achat-mobile__inputs">
                <div class="c-filter-achat-mobile__input">
                  <FormInput
                    v-model="dateMinInput"
                    size="sm"
                    title="Date de début"
                    type="date"
                    active
                    @input="libellePeriode = 'custom'"
                  >
                    Du
                  </FormInput>
                </div>

                <span class="c-filter-price__input-separator">-</span>
                <div class="c-filter-achat-mobile__input">
                  <FormInput
                    v-model="dateMaxInput"
                    size="sm"
                    title="Date de fin"
                    type="date"
                    active
                    @input="libellePeriode = 'custom'"
                  >
                    Au
                  </FormInput>
                </div>
              </div>
              <Button
                size="sm"
                radius="full"
                variant="primary"
                class="u-flex-shrink-none"
                :disabled="dateSelectorDisabled"
                @click="updateDate()"
              >
                OK
              </Button>
            </div>
            <div class="u-flex u-flex-align-start u-mt-md">
              <Icon
                variant="primary-light"
                name="info-circle"
                size="sm"
                class="u-flex-shrink-none u-mr-xxs"
              />
              <p class="u-font-14 u-color-text-light">
                Vos tickets de caisse sont conservés pendant une durée de 2 ans
              </p>
            </div>
          </div>
        </AccordionItem>
        <Divider class="u-m-none" />
        <AccordionItem
          :ref="(el) => { collapsible.push(el) }"
          :opened="false"
        >
          <template #title>
            <span class="u-font-16 u-font-700 u-py-sm">
              Montant
            </span>
          </template>

          <div class="u-p-sm">
            <div class="c-filter-achat-mobile__inputs-wrapper c-filter-achat-mobile__inputs-wrapper--montant">
              <div class="c-filter-achat-mobile__inputs">
                <div class="c-filter-achat-mobile__input">
                  <FormInput
                    v-model="montantMinInput"
                    size="sm"
                    suffix="€"
                    type="number"
                    title="Filtre prix minimum"
                  >
                    De
                  </FormInput>
                </div>

                <span class="c-filter-price__input-separator">-</span>
                <div class="c-filter-achat-mobile__input">
                  <FormInput
                    v-model="montantMaxInput"
                    size="sm"
                    suffix="€"
                    type="number"
                    title="Filtre prix minimum"
                  >
                    À
                  </FormInput>
                </div>
              </div>
              <Button
                size="sm"
                radius="full"
                variant="primary"
                class="u-flex-shrink-none"
                :disabled="montantSelectorDisabled"
                @click="updateMontant()"
              >
                OK
              </Button>
            </div>
          </div>
        </AccordionItem>
        <Divider class="u-m-none" />
        <AccordionItem
          :ref="(el) => { collapsible.push(el) }"
          :opened="false"
        >
          <template #title>
            <span class="u-font-16 u-font-700 u-py-sm">
              Magasin
            </span>
          </template>
          <div class="u-p-sm">
            <div>
              <Filtersearch
                placeholder="un magasin"
                class="u-mb-md"
                :value="searchWord"
                @input="searchMagasin"
              />
              <FormGroup class="c-filter-achat-mobile__shops u-mb-md">
                <FormRadio
                  v-for="magasin in magasinsSearchResult"
                  :key="magasin.id"
                  v-model="filtreMagasin.mag_id"
                  :value="magasin.id"
                  class="u-mb-sm"
                  @change="updateMagasin()"
                >
                  {{ magasin.attributes.cp.substring(0, 2) }} - {{ magasin.attributes.magasin }}
                </Formradio>
              </FormGroup>
            </div>
          </div>
        </AccordionItem>
        <Divider class="u-m-none" />
      </Accordion>
      <div class="u-mt-lg u-text-center">
        <Button
          link
          @click="closeAllFilters()"
        >
          <span class="u-color-black u-font-16">
            Fermer tous les filtres
          </span>
        </Button>
      </div>
    </div>
    <StickyFooter
      class="u-text-center"
      :in-dom="false"
    >
      <Button
        variant="primary"
        size="md"
        radius="full"
        @click="toggleFilter()"
      >
        Voir les tickets
      </Button>
    </StickyFooter>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/filter-achat-mobile.scss";
</style>
